import { useEffect, useState } from 'react';

import { useAnalytics } from '../../analytics';
import {
	noInvitePermissionRendered,
	noInvitePermissionRenderedTimings,
} from '../../analytics/ufoExperiences';
import { defaultOpenInviteClient } from '../../clients';
import { resolveError } from '../../utils';
import { NoInvitePermissionAnalytics } from './NoInvitePermissionAnalytics';

export default (orgId?: string) => {
	const [isLoading, setIsLoading] = useState<boolean>(!!orgId);
	const [openInviteNote, setOpenInviteNote] = useState<string | undefined>(undefined);
	const analytics = useAnalytics(NoInvitePermissionAnalytics);

	useEffect(() => {
		const getCustomisedErrorMessage = async () => {
			if (!isLoading || !orgId) {
				return;
			}

			let note;

			try {
				noInvitePermissionRendered.mark(
					noInvitePermissionRenderedTimings.getOpenInviteNote.startMark,
				);
				const response = await defaultOpenInviteClient.getOpenInviteNote(orgId);
				// TODO: remove hardcoded responseCode once available from fetchJson
				analytics.getOpenInviteNoteSent({ orgId, responseCode: 200 });
				note = response.note;
			} catch (err) {
				const { errorMessage, responseCode } = resolveError(err);
				analytics.getOpenInviteNoteSent({ errorMessage, orgId, responseCode });
			} finally {
				noInvitePermissionRendered.mark(
					noInvitePermissionRenderedTimings.getOpenInviteNote.endMark,
				);
			}

			setOpenInviteNote(note);
			setIsLoading(false);
		};

		void getCustomisedErrorMessage();
	}, [analytics, isLoading, orgId, setOpenInviteNote]);

	return {
		isLoading,
		openInviteNote,
		failedGetOpenInviteNote: !isLoading && !!orgId && openInviteNote === undefined,
	};
};
